import { useEffect, useLayoutEffect, useRef } from 'react'
import { history } from '@sparky/framework'
import CommonDrawerContexts from './CommonDrawerContexts'
import {
  UpdateGlobalTsgID,
  LoadApps,
  LoadAllInstanceData,
  LoadTreeData,
  LoadRoles,
  LoadPermissions,
  LoadPermissionSets,
  FetchCSPAccounts,
} from '../actions/GlobalActions'
import { TSG_NONE, VIEW_MANAGE_SUBSCRIPTION, VIEW_MANAGE_TENANT } from '../constants/GlobalConstants'
import { ALLOWED_LICENSE_CONTEXT } from '../../subscription/components/constants/SubscriptionConstant'
import { selectTreeNode, LOAD_TSG_ID, loadChildInstanceData } from '../reducers/actions/TreeReducer.actions'
import { mergeUserCSPAccountInfo } from '../reducers/actions/LicenseReducer.actions'
import { getVarValue, setCurrentViewing, setIsGlobalModuleOpen } from '../utils/Sparky'
import { FF_CUSTOM_ROLES_ENABLED, FF_ROLES_ENABLED } from '../utils/FeatureFlags'

const rolesEnabled = getVarValue(FF_ROLES_ENABLED, false)
const customEnabled = getVarValue(FF_CUSTOM_ROLES_ENABLED, false)

const CommonServiceContext = ({ auth, commonModule, commonDrawerState, children }) => {
  const contextTsgID = auth?.tsg_id
  const commonDrawerStateRef = useRef(commonDrawerState)
  commonDrawerStateRef.current = commonDrawerState
  const { dispatch } = commonDrawerState

  /**
   * ============= Lifecycles ===============
   */
  useEffect(() => {
    if (contextTsgID !== TSG_NONE.id && history?.location.pathname.includes(VIEW_MANAGE_TENANT)) {
      dispatch(selectTreeNode({ id: contextTsgID }))
      setCurrentViewing(VIEW_MANAGE_TENANT)
    }
    else {
      if (contextTsgID === TSG_NONE.id || !Boolean(contextTsgID)) {
        const [base, licenseCtx, hash] = history?.location.pathname.replace(/^\/(?:hub\/)?/, '').split('/')
        if (base === 'setup' && ALLOWED_LICENSE_CONTEXT.includes(licenseCtx) && hash) {
          setCurrentViewing(VIEW_MANAGE_SUBSCRIPTION)
        }
        else {
          setIsGlobalModuleOpen(false)
        }
      }
    }
  }, [contextTsgID, commonModule, dispatch])

  useEffect(() => {
    const loadInstanceData = async () => {
      UpdateGlobalTsgID(dispatch, contextTsgID, LOAD_TSG_ID)
      LoadApps(dispatch, contextTsgID)
      if (contextTsgID && !commonDrawerStateRef.current?.treeReducer?.instancesKeyBy?.[contextTsgID]) { // use ref to avoid retrigger this effect
        const instanceData = await LoadAllInstanceData([contextTsgID], contextTsgID, dispatch)
        if (instanceData && instanceData?.length) {
          dispatch(loadChildInstanceData(instanceData))
        }
      }
    }
    loadInstanceData()
  }, [contextTsgID, dispatch]) // only trigger when auth.tsg_id changed

  useLayoutEffect(() => {
    LoadTreeData(dispatch)
    if (rolesEnabled) {
      LoadRoles(dispatch)
      LoadPermissions(dispatch)
      if (customEnabled) {
        LoadPermissionSets(dispatch)
      }
    }
  }, [dispatch])

  useEffect(() => {
    if (commonModule?.tsg?.id) {
      dispatch(selectTreeNode(commonModule.tsg))
    }
  }, [commonModule, dispatch])

  useEffect(() => {
    try {
      const cspAccounts = FetchCSPAccounts({
        tsg_id: TSG_NONE.id,
        email: auth?.user?.email
      })
      cspAccounts.then((data) => {
        const userCSPAccountMerged = auth?.user?.supportAccountIds?.map((supportAccount) => {
          const cspAccount = data?.find((account) => account.support_account_id === supportAccount.accountid)
          return {
            ...supportAccount,
            is_ela: cspAccount?.is_ela || false,
            ela: cspAccount?.ela || null
          }
        })
        dispatch(mergeUserCSPAccountInfo(userCSPAccountMerged))
      })
    }
    catch (e) {
    }
  }, [contextTsgID, auth?.user, dispatch])

  return <CommonDrawerContexts>{children}</CommonDrawerContexts>
}

export default CommonServiceContext
